// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPaymentResponse

import { BillingPaymentStatus } from './enums.gen';
import { hydrateBillingPaymentInvoiceSummary, type BillingPaymentInvoiceSummary, type BillingPaymentInvoiceSummaryApiResponse } from './billingPaymentInvoiceSummary.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingPaymentApiResponse = {
	id: number;
	amount: number;
	status: BillingPaymentStatus;
	date: string;
	invoices: BillingPaymentInvoiceSummaryApiResponse[];
};

export type BillingPayment = {
	id: number;
	amount: number;
	status: BillingPaymentStatus;
	date: DateTime;
	invoices: BillingPaymentInvoiceSummary[];
};

export function hydrateBillingPayment(data: BillingPaymentApiResponse): BillingPayment {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
		invoices: data.invoices.map(hydrateBillingPaymentInvoiceSummary),
	};
}